function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgTravelling = function SvgTravelling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF2C5C"
    },
    d: "M101.501,384.806L25.402,324.95c-4.157-3.127-5.518-8.647-3.023-12.26l0,0 c12.197-17.664,35.693-23.697,58.779-15.092l68.824,39.041L101.501,384.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF2C5C"
    },
    d: "M127.039,410.344l60.013,76.256c3.127,4.157,8.647,5.518,12.26,3.023l4.537-3.133 c14.941-10.316,20.043-30.19,12.765-49.717l-41.251-74.754L127.039,410.344z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E62753"
    },
    points: "105.941,311.655 62.885,354.432 101.501,384.806 149.983,336.638 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3D3DB"
    },
    d: "M122.118,150.38L122.118,150.38c-9.557-9.557-10.313-24.785-1.775-35.262 c12.212-14.986,27.512-31.673,36.69-40.851c12.556-12.556,13.653-11.056,27.068-19.279c1.975-1.211,4.524-0.919,6.162,0.719 l26.529,26.529c1.638,1.638,1.929,4.187,0.719,6.162c-8.223,13.415-6.723,14.511-19.279,27.067 c-9.178,9.178-25.865,24.478-40.851,36.69C146.903,160.692,131.674,159.937,122.118,150.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3D3DB"
    },
    d: "M361.622,389.884L361.622,389.884c-9.557-9.557-10.313-24.785-1.775-35.262 c12.212-14.986,27.512-31.673,36.69-40.851c12.556-12.556,13.652-11.056,27.068-19.279c1.975-1.211,4.524-0.919,6.162,0.719 l26.529,26.529c1.638,1.638,1.929,4.187,0.719,6.162c-8.223,13.415-6.723,14.511-19.279,27.068 c-9.178,9.178-25.865,24.478-40.851,36.69C386.407,400.197,371.179,399.441,361.622,389.884z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF2C5C"
    },
    d: "M241.923,240.842l93.887-93.887L44.968,55.575c-5.989-1.529-11.943-0.073-15.905,3.889L4.491,84.036 c-8.229,8.229-4.697,23.314,6.92,29.552L241.923,240.842z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E62753"
    },
    points: "270.094,126.308 186.278,210.124 241.923,240.842 335.81,146.955 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF2C5C"
    },
    d: "M271.16,270.079l93.887-93.887l91.38,290.842c1.529,5.989,0.073,11.943-3.889,15.905l-24.572,24.572 c-8.229,8.229-23.314,4.697-29.552-6.92L271.16,270.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0F3FC"
    },
    d: "M448.371,136.723L290.643,294.45c-26.466,26.466-54.603,51.152-84.061,73.75l-75.044,57.568 c-17.373,13.328-38.035,14.94-49.14,3.835l0,0c-11.105-11.105-9.493-31.767,3.835-49.14l57.568-75.044 c22.598-29.458,47.283-57.594,73.75-84.061L375.279,63.631c21.562-21.562,46.326-39.527,72.487-51.861 c22.529-10.621,46.476-17.275,58.108-5.643c11.632,11.632,4.978,35.579-5.643,58.108 C487.898,90.398,469.933,115.161,448.371,136.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3D3DB"
    },
    d: "M505.874,6.128c-4.094-4.094-9.718-5.916-16.265-6.103c0.471,12.114-4.782,27.478-11.739,42.234 c-12.333,26.161-30.298,50.925-51.861,72.487L268.282,272.473c-26.466,26.466-54.603,51.152-84.061,73.749l-75.044,57.568 c-11.05,8.477-23.428,12.206-33.834,10.946c0.782,5.775,3.113,10.924,7.055,14.866l0,0c11.105,11.105,31.767,9.493,49.14-3.835 l75.044-57.568c29.458-22.598,57.594-47.283,84.061-73.75l157.728-157.726c21.562-21.562,39.527-46.326,51.861-72.487 C510.852,41.707,517.506,17.76,505.874,6.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51C4F5"
    },
    d: "M461.44,106.517l-5.386,5.386c-5.002,5.002-60.956-50.952-55.954-55.954l5.386-5.386 c3.395-3.395,8.378-4.465,12.436-2.67l0,0c20.219,8.944,37.244,25.97,46.189,46.189l0,0 C465.904,98.139,464.835,103.122,461.44,106.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E62753"
    },
    d: "M99.44,420.062c-1.919,0-3.839-0.732-5.303-2.197c-2.929-2.929-2.929-7.678,0-10.606l65.496-65.496 c2.929-2.929,7.678-2.929,10.606,0c2.929,2.929,2.929,7.678,0,10.606l-65.496,65.496C103.279,419.329,101.36,420.062,99.44,420.062z "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTravelling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/travelling.905e9508.svg";
export { ForwardRef as ReactComponent };